import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SessionService } from 'projects/shared-components/authentication/session-service.service';
import { TerminalDto } from 'projects/shared-components/shell-communication/dtos/terminal-dto.class';
import { ComboDto, ComboGroupDto, GetAvailableBucketsReply, PortfolioDto } from 'projects/shared-components/shell-communication/shell-dto-protocol';
import { DetectSetterChanges } from 'projects/shared-components/utils';
import { PortfoliosService } from '../../../../portfolios/portfolios.service';

export class BucketSelectorModel {

   constructor(
      private readonly _sessionService: SessionService,
      private readonly _cd: ChangeDetectorRef) {
   }

   //
   
   private _availableBuckets: GetAvailableBucketsReply;

   //

   terminals: TerminalDto[];

   portfolios: PortfolioDto[];

   combos: ComboDto[];

   comboGroups: ComboGroupDto[];

   selectedTerminal: TerminalDto;

   selectedPortfolio: PortfolioDto;

   selectedCombo: ComboDto;

   selectedComboGroup: ComboGroupDto;

   async init(pfService: PortfoliosService): Promise<void> {
      this.terminals = this._sessionService.loginResult.availableTerminals.filter(x => !x.isProxy);
      this._availableBuckets = await pfService.getAvailableBuckets();
   }

   //

   onTerminalChange(t: TerminalDto) {
      this.selectedTerminal = t;
      if (t) {
         this.portfolios = this._availableBuckets.portfolios.filter(x => x.terminalId === t.terminalId);
         this.combos = [];
         this.comboGroups = [];
      } else {
         this.portfolios = [];
         this.combos = [];
         this.comboGroups = [];
      }

      this._cd.detectChanges();
   }

   //

   onPortfolioChange(p: PortfolioDto) {
      this.selectedPortfolio = p;
      if (p) {
         this.combos = this._availableBuckets.combos.filter(c => c.portfolioId === p.portfolioId);
         this.comboGroups = [];
      } else {
         this.combos = [];
         this.comboGroups = [];
      }

      this._cd.detectChanges();
   }

   //

   onComboChange(c: ComboDto) {
      this.selectedCombo = c;
      if (c) {
         this.comboGroups = this._availableBuckets.comboGroups.filter(cg => cg.comboId === c.comboId);
      } else {
         this.comboGroups = [];
      }

      this._cd.detectChanges();
   }

   //

   reset() {
      this.selectedComboGroup = this.selectedCombo = this.selectedPortfolio = this.selectedTerminal = null;
      this.comboGroups = [];
      this.combos = [];
      this.portfolios = [];
      this.terminals = [];

      this._cd.detectChanges();
   }
}

@Component({
   selector: 'ets-bucket-selector',
   templateUrl: 'bucket-selector.component.html',
   styleUrls: ['bucket-selector.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush
})

export class BucketSelectorComponent implements OnInit, AfterViewInit {
   constructor(
      private _changeDetector: ChangeDetectorRef,
      private _portfolioSerivce: PortfoliosService,
      private _sessionService: SessionService
   ) { }
   //

   private _isLoading = false;
   get isLoading(): boolean {
      return this._isLoading;
   }
   @DetectSetterChanges()
   set isLoading(v: boolean) {
      this._isLoading = v;
   }

   //

   model: BucketSelectorModel;

   //

   async ngOnInit() { 
      this.model = new BucketSelectorModel(this._sessionService, this._changeDetector);
   }

   //

   async ngAfterViewInit(): Promise<void> {
      try {
         
         this.isLoading = true;
         await this.model.init(this._portfolioSerivce);

      } finally {
         this.isLoading = false;
      }
   }


}
